import React from 'react'
import PropTypes from 'prop-types'
import { Route, Redirect } from 'react-router-dom'
import { useSelector } from 'react-redux'

import AsyncCancelSubscriptionLayout from './index'
import { getModalLocation } from '../../lib/modal'
import { useIsAuthenticated } from '../../hooks/use-is-authenticated'
import { CANCEL_SUBSCRIPTION_SCREENS } from '../../constants'

const CancelSubscriptionRoute = ({ component: Component, ...rest }) => {
  const isAuthenticated = useIsAuthenticated()
  const maintenanceModeIsEnabled = useSelector(state => state.maintenance.mode)

  const renderRoute = (props) => {
    if (maintenanceModeIsEnabled) {
      return null
    }

    if (isAuthenticated) {
      return (
        <AsyncCancelSubscriptionLayout>
          <Component {...props} />
        </AsyncCancelSubscriptionLayout>
      )
    }

    return (
      <Redirect
        to={getModalLocation(
          { pathname: CANCEL_SUBSCRIPTION_SCREENS.CANCEL_SUBSCRIPTION_LANDING.path },
          'login'
        )}
      />
    )
  }

  return <Route {...rest} render={renderRoute} />
}

CancelSubscriptionRoute.propTypes = {
  component: PropTypes.func.isRequired
}

export default CancelSubscriptionRoute
